import McPageHelpers from '../McPageHelpers'
import useFirmDetails from '../../../hooks/useFirmDetails'

const FirmWebCell = ({ row }) => {
  const firm = useFirmDetails(row.urlCode)
  const web = (firm.web && firm.web !== '.') ? firm.web : row.web
  return McPageHelpers.generateCardHyperlink({ ...row, web })
}

export default FirmWebCell
